export default "__VITE_ASSET__ZWhQznTO__"